/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-14 00:00:00
 *
 *******************************************************/
// @flow
import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import MainMenu from 'src/components/containers/main-menu';
import ShopifyIntegrationScreenList from 'src/components/containers/shopify-integration/screen.list';
import ShopifyIntegrationScreenNew from 'src/components/containers/shopify-integration/screen.new';
import ShopifyIntegrationScreenUpdate from 'src/components/containers/shopify-integration/screen.update';
import { routes } from 'src/routes';

import * as themeIntegrationAction from 'actions/shopify-integration/theme-integration-actions';

type Props = {
  installStatus: string,
  installAppStatus: string,
  themeSetupV2: boolean
};

type ComposedProps = Props & WithI18nProps;

type State = {};

class ShopifyIntegration extends Component<ComposedProps, State> {
  constructor(props) {
    super(props);
    this.mapRouteElement = {
      [routes.shopifyIntegration.view()]: ShopifyIntegrationScreenList,
      [routes.shopifyIntegration.viewThemeWidget(':themeId')]: ShopifyIntegrationScreenUpdate,
      [routes.shopifyIntegration.newThemeWidget(':themeId')]: ShopifyIntegrationScreenNew
    };
  }

  render() {
    const Screen = this.mapRouteElement[this.props.match.path];
    return (
      <div className="BC-Page BC-Page__ShopifyIntegration">
        <MainMenu menuId="menu-integration-shopify-integration" />

        <Screen
          saveSelectedTheme={this.saveSelectedTheme}
          saveIntegratedTemplateInstance={this.saveIntegratedTemplateInstance}
          match={this.props.match}
        />
      </div>
    );
  }

  handleChangeScreen = screenName => {
    this.setState({ screen: screenName });
  };

  saveSelectedTheme = selectedThemeId => {
    this.props.updateFieldReducer('selectedThemeId', selectedThemeId);
  };

  saveIntegratedTemplateInstance = integratedTemplateInstance => {
    this.props.updateFieldReducer('templateInstance', integratedTemplateInstance);
  };
}

const mapStateToProps = (state, props) => {
  const { themeIntegration = {} } = state;

  return {
    // Check theme integration status
    selectedTheme: _.get(themeIntegration, 'selectedTheme', {}),
    selectedThemeId: _.get(themeIntegration, 'selectedThemeId', ''),
    checkingTheme: _.get(themeIntegration, 'checkingTheme', false),
    integratedTemplateInstance: _.get(themeIntegration, 'templateInstance', {})
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  updateFieldReducer: (fieldName, data) =>
    dispatch(themeIntegrationAction.handleUpdateField(fieldName, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(ShopifyIntegration));
